import React from 'react';

/**
 * What a CLOSED section's header says (KPR-581), so a folded section never
 * hides that something in it needs a person (utils/sectionSummary).
 *
 *   form    the field count, then — to the right — "N required" in the warning
 *           colour while a required field in it is still blank, and the
 *           "Needs attention" flag while a value in it is refused. Never a
 *           "filled" figure: on the form, what is filled is what you are doing.
 *   view    a muted "6 of 9 filled", then the same "N required".
 *
 * Nothing renders for an empty section, rather than "0 of 0 filled".
 */
export default function SectionHeaderStatus({ summary, surface = 'form' }) {
	const { total = 0, filled = 0, required = 0, invalid = 0 } = summary || {};
	const isView = surface === 'view';
	return (
		<>
			{total > 0 ? (
				isView
					? <span className="section-status__filled">{filled} of {total} filled</span>
					: <span className="form-panel__count">{total}</span>
			) : null}
			{required > 0 || invalid > 0 ? (
				<span className="section-status__alerts">
					{required > 0 ? <span className="section-status__required">{required} required</span> : null}
					{invalid > 0 ? <span className="form-panel__attention section-status__flag">Needs attention</span> : null}
				</span>
			) : null}
		</>
	);
}
